import React from "react";
import {createRoot} from "react-dom/client";
import SiteSearch from "../components/SiteSearch";

const renderSiteSearch = ($) => {

	const searchRootElement = document.getElementById("js-site-search");
	const searchRoot = createRoot(searchRootElement);

	searchRoot.render (
		<SiteSearch />
	)
};

export default renderSiteSearch;
